import {
    SetItem,
    GetItem,
    isField,
    SubmitButtonProps,
    ValidateFields,
    RenderedFlatObject,
    Files, itemsCloneDeep
} from "@cfinnestad/react-form-builder";
import React, {useCallback, useState} from "react";
import axios from "axios";
import {Button, ThemeProvider} from "@mui/material";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const SubmitButton = ( props: SubmitButtonProps ) => {
    const [submitting, setSubmitting] = useState(false)

    const {executeRecaptcha} = useGoogleReCaptcha()

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        return executeRecaptcha('submit');

    }, [executeRecaptcha]);

    const submit = async () => {
        if(submitting) return
        setSubmitting(true)

        console.log('before validation...', props.items)
        if (!ValidateFields(props.items, props.options)) {
            console.error('form errors present, skipping submission')
            setSubmitting(false)
            return
        }

        const token = await handleReCaptchaVerify()

        // Send to forms backend
        console.log('Items', props.items)
        // console.log('options', props.options.custom)
        const files: Files = {}
        let data = RenderedFlatObject(props.items, files);
        console.log('data', data)
        const formData = new FormData()
        const hasFiles = Object.keys(files).length > 0;
        if (hasFiles) {
            console.log('FILES',files)
            formData.append('data',JSON.stringify(data))
            Object.entries(files).map(([name,value]) => (
                value.map((file) => {
                    console.log(name+'[]',file)
                    formData.append(name + '[]', file)
                })
            ))
            data = formData
        } else {
            data = JSON.stringify(data)
        }
        console.log('FormData', formData)
        let headers: object = {
            'x-csrf-token': props.options.custom?.csrfToken,
            'recaptchaToken': token ? token : '',
        }
        if (!hasFiles) {
            headers = {...headers, 'Content-Type': 'application/json'}
        }
        console.log('headers', headers)
        await axios.post(
            props.options.custom?.submitUrl + location.search,
            data,
            {
                headers: headers
            })
            .then(res => {
                console.log('Axios response...', res)
                props.options.custom?.setDisplayThankyou(true)
            })
            .catch(err => {
                if(err.response) {
                    console.log('Axios error...', err.response.data)
                    const { errors } = err.response.data
                    let first = null
                    let items = itemsCloneDeep(props.items)
                    for (const id in errors) {
                        first = first ?? id
                        const item = GetItem(id, items)
                        if (item !== undefined && isField(item)) {
                            console.log('id:',id,'Error:', errors[id][0])
                            item.errorText = errors[id][0]
                            console.log('Setting Item:', item)
                            SetItem(item, items)
                        }
                    }
                    props.options.setItems(items)
                    document.getElementById(first ?? 'xxxxx')?.focus();
                }
            })
        setSubmitting(false)
    }

    return <ThemeProvider theme={props.options.muiTheme}>
        {
            // @ts-ignore
        <Button variant="contained" color={props.color ?? 'primary'} onClick={ submit } disabled={submitting}>
            {props.label}
        </Button>
        }
    </ThemeProvider>
}

export default SubmitButton
